import { render, staticRenderFns } from "./ApproveMaterialDialog.vue?vue&type=template&id=e94ec548&scoped=true&"
import script from "./ApproveMaterialDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveMaterialDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApproveMaterialDialog.vue?vue&type=style&index=0&id=e94ec548&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94ec548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94ec548')) {
      api.createRecord('e94ec548', component.options)
    } else {
      api.reload('e94ec548', component.options)
    }
    module.hot.accept("./ApproveMaterialDialog.vue?vue&type=template&id=e94ec548&scoped=true&", function () {
      api.rerender('e94ec548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/components/ApproveMaterialDialog.vue"
export default component.exports